import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-long-can-a-gif-be";

export const Route = createFileRoute("/blog/how-long-can-a-gif-be")(options);
